const ALLOWED_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
  'image/gif',
]);

const EXT_TO_MIME: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  heic: 'image/heic',
  heif: 'image/heif',
  gif: 'image/gif',
};

function mimeFromFilename(name: string): string | null {
  const ext = name.split('.').pop()?.toLowerCase();
  return ext ? EXT_TO_MIME[ext] ?? null : null;
}

/** Accept by MIME or common photo extensions (HEIF often has empty type on upload). */
export function isContributionImageFile(file: File): boolean {
  if (file.type && ALLOWED_IMAGE_TYPES.has(file.type.toLowerCase())) return true;
  if (file.type === 'image/svg+xml') return false;
  const guessed = mimeFromFilename(file.name);
  return guessed != null && ALLOWED_IMAGE_TYPES.has(guessed);
}

export function contributionImageMime(file: File): string {
  const type = file.type?.toLowerCase();
  if (type && ALLOWED_IMAGE_TYPES.has(type)) return type;
  return mimeFromFilename(file.name) ?? type ?? 'application/octet-stream';
}

/** Extract image files from a clipboard event (screenshot, copied image, or file paste). */
export function imageFilesFromClipboard(clipboard: DataTransfer | null): File[] {
  if (!clipboard) return [];

  const fromFiles = Array.from(clipboard.files).filter(isContributionImageFile);
  if (fromFiles.length > 0) return fromFiles;

  const fromItems: File[] = [];
  for (const item of Array.from(clipboard.items)) {
    if (item.kind !== 'file') continue;
    const file = item.getAsFile();
    if (file && isContributionImageFile(file)) fromItems.push(file);
  }
  return fromItems;
}

export function isAllowedContributionImageType(type: string): boolean {
  return ALLOWED_IMAGE_TYPES.has(type.toLowerCase());
}
